export const SAMPARK = 'sampark';
